import { useEffect, useState } from 'react';
import { fetchDriverMissions } from '@/domains/driver/services/driver.service';
import { useDriverLocationSender } from '@/backoffice/hooks/useDriverLocationSender';

/** Envoie la position GPS du livreur pour la première mission en cours. */
export function DriverGpsTracker() {
  const [activeOrderId, setActiveOrderId] = useState<number | null>(null);

  useEffect(() => {
    fetchDriverMissions('in_progress')
      .then((missions) => setActiveOrderId(missions[0]?.id ?? null))
      .catch(() => setActiveOrderId(null));

    const interval = setInterval(() => {
      fetchDriverMissions('in_progress')
        .then((missions) => setActiveOrderId(missions[0]?.id ?? null))
        .catch(() => setActiveOrderId(null));
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  useDriverLocationSender({
    orderRequestId: activeOrderId,
    enabled: activeOrderId != null,
  });

  return null;
}
